<template>
    <div class="px-0">
        <v-container class="px-0" style="max-width: 100% !important">
            <v-row class="px-3 pt-4 pb-2" >
                <v-col sm="6" md="4" class="py-0">
                    <v-text-field
                        v-model="props.search"
                        append-icon="search"
                        :label="$t('locations.search')"
                        single-line
                        hide-details
                        class="mb-4 py-0 px-2 mt-0"
                        style="background-color: var(--v-white_highlight-base); border: 1px solid black; border-radius:5px"
                    ></v-text-field>
                </v-col>
                <v-spacer></v-spacer> 
                <v-col cols="6" align="end" class="py-0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="right tools-view-height mx-1" outlined color="secondary" @click="downloadBarcodes()" style="max-width: 40px !important; min-width: 40px !important" >
                                <v-icon class="material-icons-outlined" small>file_download</v-icon>
                            </v-btn>
                        </template>

                        <span>{{ $t('locations.download_barcodes') }}</span>
                    </v-tooltip>

                    <v-btn class="right mx-3 tools-view-height" outlined color="secondary" @click="modalImport = true">
                        {{ $t('locations.import') }}
                        <v-icon class="px-1" small>cloud_upload</v-icon>
                    </v-btn>
                    <v-btn class="right white_highlight--text" color="secondary" :to="'/locations/create'" >
                        {{ $t('locations.new') }}
                    </v-btn>
                </v-col>
            </v-row>
            <v-card class="px-0 size_buttons">
                <v-card-text class="py-3">
                    <v-row>
                        <v-col class="py-0">
                            <datatable show-select v-model="selected" :pagination="[10, 25, 50, 100]" :props="{headers:headers, items: props.items, search:props.search}" :itemsLength="props.meta.total" :options.sync="pagination.pendings" @update:options="(options) => onOptionsChange(options)" @methodHandler="methodHandler"></datatable>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>    
            <v-dialog v-model="modalImport" persistent max-width="90%">
                <v-card>
                    <v-card-title class="justify-center">
                        <v-spacer></v-spacer>
                        {{ $t('locations.import_locations') }}
                        <v-spacer></v-spacer>
                        <v-btn color="secondary" small icon @click="stepper2 = 1;modalImport = false"><v-icon small>close</v-icon></v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-stepper v-model="stepper2">
                            <v-stepper-header>
                                <v-stepper-step :complete="stepper2 > 1" step="1" color="secondary">{{$t('locations.select_locations_file')}}</v-stepper-step>
                                <v-divider></v-divider>
                                <v-stepper-step :complete="stepper2 > 2" step="2" color="secondary">{{ $t('locations.verify_data') }}</v-stepper-step>
                                <v-divider></v-divider>
                            </v-stepper-header>

                            <v-stepper-items>
                                <v-stepper-content step="1" class="mx-0 px-0">
                                    <v-card flat class="mb-5">
                                        <v-form ref="form2" lazy-validation>
                                            <v-row class="mx-0 px-0" justify="center" align="center">
                                                <v-col cols="10">
                                                    <v-file-input v-model="inputFile2" accept=".csv" color="secondary" :label="$t('locations.select_locations_file')"></v-file-input>
                                                </v-col>
                                                <v-col cols="2">
                                                    <v-tooltip top>
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-btn class="mx-0" small color="secondary" fab dark v-bind="attrs" v-on="on" @click="stepper2 = 3">
                                                                <v-icon aria-hidden="false" color="white" small>
                                                                    help
                                                                </v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>{{ $t('upload_massive.help') }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                        </v-form>
                                    </v-card>
                                    
                                    <div class="d-flex">
                                        <v-spacer></v-spacer>
                                        <v-btn class="right mr-2 white_highlight--text" color="secondary" @click="uploadLocations" >
                                            {{ $t('locations.next') }}
                                        </v-btn>
                                    </div>
                                </v-stepper-content>

                                <v-stepper-content step="2">
                                    <v-card flat class="mb-5">
                                        <v-card-text class="my-0 py-0">
                                            <p class="my-0 py-0">{{readRows2.length}} {{ $t('locations.locations_in_file') }}</p>
                                        </v-card-text>
                                        <v-simple-table v-if="this.readRows2.length > 0" fixed-header height="300px">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th v-for="(th, key) in sTHeaders2" :key="key" class="text-left">{{ th }}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(item, i) in readRows2" :key="i">
                                                        <td v-for="(td, j) in item.split(',')" :key="j">{{ td }}</td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </v-card>

                                    <div class="d-flex">
                                        <v-spacer></v-spacer>
                                        <v-btn class="mx-3" text @click="stepper2 = 1; sTHeaders2 = []; readRows2 = []">{{ $t('locations.go_back') }}</v-btn>
                                        <v-btn color="secondary" class="white_highlight--text" @click="saveLocations">
                                            {{ $t('locations.save_data') }}
                                        </v-btn>
                                    </div>
                                </v-stepper-content>

                                <v-stepper-content step="3">
                                    <p class="py-0 my-0">1.- Conserve todos los encabezados en el orden presentado y sin modificarlos.</p> 
                                    <p class="py-0 my-0">2.- Llene la información de acuerdo al campo solicitado, no utilice comas en ninguno de los campos, evite el uso de signos de interrogación, comillas o signos de admiración.</p> 
                                    <p class="py-0 my-0">3.- A continuación se muestra una línea de ejemplo para familiarizarse con el formato.</p> 
                                    <p class="py-0 my-0">4.- El archivo de ubicaciones debe ser formato CSV.</p> 
                                    <p>5.- Si el campo presenta la leyenda 'Opcional' este campo puede ir vacío.</p> 
                                    <p class="py-0 my-0">Columnas: </p>
                                    <v-simple-table fixed-header>
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                   <th class="text-left" style="padding: 0 5px !important;">name</th>
                                                   <th class="text-left" style="padding: 0 5px !important;">level</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>Location 1</td>
                                                    <td>1</td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    <v-row align="center" justify="center" class="my-3">
                                        <v-btn color="secondary" class="white_highlight--text" @click="stepper2 = 1">
                                            {{ $t('products.go_back') }}
                                        </v-btn>
                                    </v-row>
                                </v-stepper-content>
                            </v-stepper-items>
                        </v-stepper>
                    </v-card-text>
                </v-card>
            </v-dialog>
            </v-container>     
        <v-snackbar v-model="snackbar.visible" :timeout="4000" :color="snackbar.color" style="text-align: center; color: var(--v-accent-base);">{{ snackbar.text }}</v-snackbar>
    </div>
</template>
<script>

import JSZip from 'jszip';
import FileSaver from 'file-saver';
import { HttpLocationRepository } from '../infrastructure/repositories/location_repository';
import { locationDownloadBarcodeUseCase } from '../application/use_cases/location_download_barcode_use_case'
import { locationIndexUseCase } from '../application/use_cases/location_index_use_case'

export default {
    computed: {
        rules_required(){return [v => !!v || this.$t('create_appointment.validations.required_field')]},
        headers(){
            return [
                { text: this.$t('locations.id'), align: "center", value: 'id', class: 'text-uppercase' },
                { text: this.$t('locations.name'), align: "center", value: 'name', class: 'text-uppercase' },
                { text: this.$t('locations.warehouse'), align: "center", value: 'warehouse.name', class: 'text-uppercase', sortable: false },
                { text: this.$t('locations.stacking_level'), align: "center", value: 'stacking_level', class: 'text-uppercase', sortable: false },
                { text: this.$t('locations.status'), align: "center", value: 'is_available', class: 'text-uppercase', sortable: false },
                { text: this.$t('locations.actions'), align: "center", value: 'actions', class: 'text-uppercase', sortable: false },
            ];
        } 
    },
    data(){
        return {
            snackbar: {
                visible: false,
                color: 'primary',
                text: ''
            },
            modalImport: false,
            inputFile2: [],
            readFile2: '',
            readRows2: [],
            stepper2: 1,
            sTHeaders2:'',
            idLocation: '',
            selected: [],
            description: '',
            props: {
                search: '',
                items: [],
                meta: {
                    total: 0,
                    total_pages: 0,
                    per_page: 10,
                    page: 1
                },
                sort_by: []
            },
            debounceTimer: null,
            pagination: {page: 1, itemsPerPage: 10, sortBy: [], sortDesc: [], groupBy: [], groupDesc: [], multiSort: false, mustSort: false},
        }
    },
    mounted(){
        this.$store.state.module = "headers.locations";
    },
    methods: {
        methodHandler(object){
            this[object.methodName](object.parameters)
        },
        async index(){
            try{
                this.props.items = [];

                const res = await locationIndexUseCase( this.props.meta.page, this.props.meta.per_page, this.props.search, 'id,name,is_available,warehouse,level,bay_id', this.props.sort_by, HttpLocationRepository);
                this.props.items = res.data;
                this.props.meta = res.meta;
            } catch (e) {
                console.log(e);
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }
        },
        uploadLocations(){
            if(this.$refs.form2.validate()){
                this.createInput2(this.inputFile2);
            }
        },
        createInput2(file) {
            const promise = new Promise((resolve) => {
                const reader = new FileReader();
                // const vm = this;
                reader.onload = () => {
                    resolve((this.readFile = reader.result));
                };
                reader.readAsText(file);
            });

            promise.then(
                result => {
                    /* handle a successful result */
                    this.readRows2 = result.split('\r\n');
                    this.sTHeaders2 = this.readRows2[0].split(',');
                    this.readRows2.shift();
                    this.stepper2 = 2;
                },
                error => {
                    /* handle an error */ 
                    console.log(error);
                }
            );
        },
        saveLocations(){
            this.modalImport = false;
            this.$store.state.loaderProps.visible = true;
            const locations = [];
            if(this.readRows2.length > 0){
                this.readRows2.forEach((x) => {
                    const num = x.split(',');
                    locations.push({
                        'name': num[0],
                        'stacking_level': num[1]
                    });
                })
                const lsToken = localStorage.getItem("access_token")
                this.$http.post(this.$store.state.chronosApi + 'importLocations', {locations: locations}, { headers: { Authorization: lsToken } })
                .then((response) => {
                    if(response.data.status === 201){
                        this.modal2 = false;
                        this.stepper2 = 1;
                        this.sTHeaders2 = [];
                        this.readRows2 = [];
                        this.inputFile2 = null;
                        this.snackbar = {
                            visible: true,
                            color: 'success2',
                            text: this.$t('locations.responses.ok')
                        };
                        this.index();
                    }
                })
                .catch((error) => {
                    this.snackbar = {
                        visible: true,
                        color: 'error',
                        text: "error " + error.response.data.message
                    };
                })
                .finally(() => {
                    this.$store.state.loaderProps.visible = false;
                })
            }
            else{
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: this.$t('locations.validations.select_file_first')
                };
            }
        },
        async downloadLabels(location){
            this.$store.state.loaderProps.visible = true;
            const lsToken = localStorage.getItem("access_token");
            const response = await this.$http.get(this.$store.state.chronosApi + 'locations_label?id=' + location, {headers: {Authorization: lsToken}})
            var zip = new JSZip();
            
            if(response.data.status != 200){
                this.$store.state.loaderProps.visible = false;
                return;
            }

            for(var i = 1; i <= response.data.pallets.length; i++){
                this.$store.state.loaderProps.text = localStorage.getItem('language') == 'en' ? "LOADING... " + (i) + " of " + response.data.pallets.length.toString() : "CARGANDO... " + (i) +  " de " + response.data.pallets.length.toString()

                const file = await this.getFileLabel(response.data.location, response.data.pallets[i-1]);
                zip.file(response.data.location.name + '_' + i + '.png', file.data);
            }

            this.$store.state.loaderProps.text = localStorage.getItem('language') == 'en' ? "LOADING..." : "CARGANDO...";
            zip.generateAsync({type:"blob"}).then(function(content) {
                FileSaver.saveAs(content, "Labels_locaiton_" + response.data.location.id + ".zip")
            }, function(err){
                console.log(err)
            })

            this.$store.state.loaderProps.visible = false;
        },
        async getFileLabel(location, pallet){
            const lsToken = localStorage.getItem("access_token");
            const file = await this.$http.get(this.$store.state.chronosApi + '/locations_get_label?pallet=' + pallet.pallet + '&sku=' + pallet.sku +'&batch=' + pallet.batch + '&reference=' + pallet.reference + '&epc=' + pallet.epc + '&name=' + pallet.name + '&location=' + location.name, {headers: {Authorization: lsToken}, responseType:'blob'});
            return file;
        },
        async downloadSingleBarcode(location){
            try{
                const result = await locationDownloadBarcodeUseCase(location, HttpLocationRepository);

                const base64WithoutPrefix = result[0].image.split(',')[1];

                const byteCharacters = atob(base64WithoutPrefix);
                const byteNumbers = new Array(byteCharacters.length);
                for (let i = 0; i < byteCharacters.length; i++) {
                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                }
                const byteArray = new Uint8Array(byteNumbers);

                const mimeType = result[0].image.match(/^data:(.*);base64/)[1];

                const blob = new Blob([byteArray], { type: mimeType });

                FileSaver.saveAs(blob, "barcode-" + location.name + ".png");

            }catch(e){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }            
        },
        async handleSelected(value){
            this.selected = value.map(x => x.id);
            console.log(this.selected);
        },
        async downloadBarcodes() {
            if(this.selected.length == 0) return;
            var zip = new JSZip();
            try{
                const result = await locationDownloadBarcodeUseCase(this.selected.join(','), HttpLocationRepository);
                
                for(var item of result){
                    const base64WithoutPrefix = item.image.split(',')[1];

                    const byteCharacters = atob(base64WithoutPrefix);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);

                    const mimeType = item.image.match(/^data:(.*);base64/)[1];

                    const blob = new Blob([byteArray], { type: mimeType });
                    zip.file("barcode-" + item.location + ".png", blob);                    
                }

                zip.generateAsync({type:"blob"}).then(function(content) {
                    FileSaver.saveAs(content, "Barcodes.zip")
                }, function(err){
                    console.log(err)
                })
            }catch(e){
                this.snackbar = {
                    visible: true,
                    color: 'error',
                    text: e.response == null? e : e.response.data.fault.message
                }
            }       
        },
        async onOptionsChange(options) {
            this.props.meta.page = options.page;
            this.props.meta.per_page = options.itemsPerPage;
            
            if(options.sortBy.length > 0){
                this.props.meta.page = 1;
                this.props.sort_by = [{field: options.sortBy[0], direction: options.sortDesc[0] ? 'desc' : 'asc'}];
            } 
            else if(options.sortBy.length != this.props.sort_by.length) {
                this.props.meta.page = 1;
                this.props.sort_by = [];
            } 
            
            this.index();
        },
    },
    watch: {
        'props.search': async function(){
            clearTimeout(this.debounceTimer)

            this.debounceTimer = setTimeout(() => {
                this.index();
            }, 800);
        }
    }
}
</script>

<style>

</style>